export default {
  INITIAL: 'initial',
  PLAY_REQUESTED: 'play-requested',
  PLAYING: 'playing',
  PAUSE_REQUESTED: 'pause-requested',
  PAUSED: 'paused',
  ENDED: 'ended',
};



// WEBPACK FOOTER //
// ./~/wix-vod-shared/src/common/constants/video-playback-status.js